import { getSignupPage } from "../../../config/signupContent.js";
import { buildAnimatedTitle } from "../../HeroTitleAnimation.js";

export function createSignupHeroSection() {
  const { hero } = getSignupPage();
  const section = document.createElement("section");
  section.id = "hero";
  section.className = "section hero signup-hero";

  section.innerHTML = `
    <div class="section__inner signup-hero__inner">
      <div class="signup-hero__content reveal">
        <h1 class="hero__title">${buildAnimatedTitle(hero.titleSegments)}</h1>
        <p class="hero__subtitle">${hero.subtitle}</p>
      </div>
    </div>
  `;

  return section;
}
